import React from 'react';
import { Link } from 'react-router-dom';

export default function MentionsLegales() {
  return (
    <>
      <section className="bg-slate-900 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link><span>/</span>
            <span className="text-white">Mentions légales</span>
          </div>
          <h1 className="text-3xl font-extrabold text-white">Mentions légales</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">

          <h2>Éditeur du site</h2>
          <p>
            <strong>Apex Rénovation</strong><br />
            Société par actions simplifiée (SAS)<br />
            Siège social : 2 rue du Gué de la Chapelle, 36250 Saint-Maur<br />
            SIREN : 102 941 028<br />
            SIRET : 102 941 028 00015<br />
            RCS Châteauroux<br />
            Code APE : 43.22A — Travaux d'installation d'eau et de gaz en tous locaux<br />
            Email : <a href="mailto:contact@apexrenovation.fr">contact@apexrenovation.fr</a>
          </p>
          <p>
            Directeur de la publication : Hadrien Mauve, Président
          </p>

          <h2>Hébergement</h2>
          <p>
            Ce site est hébergé par <strong>Netlify, Inc.</strong><br />
            44 Montgomery Street, Suite 300, San Francisco, CA 94104, États-Unis<br />
            <a href="https://www.netlify.com" target="_blank" rel="noopener noreferrer">www.netlify.com</a>
          </p>

          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes) est la propriété exclusive d'Apex Rénovation SAS ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, distribution, modification ou utilisation à des fins commerciales sans autorisation écrite préalable est strictement interdite.
          </p>

          <h2>Responsabilité</h2>
          <p>
            Apex Rénovation SAS s'efforce de maintenir les informations publiées sur ce site aussi précises et à jour que possible. Cependant, la société ne saurait être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour des informations. Les estimations de prix fournies via le configurateur de devis sont indicatives et non contractuelles ; elles ne constituent pas un devis définitif.
          </p>

          <h2>Liens hypertextes</h2>
          <p>
            Ce site peut contenir des liens vers des sites tiers. Apex Rénovation SAS n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leur disponibilité.
          </p>

          <h2>Droit applicable</h2>
          <p>
            Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux compétents du ressort du siège social d'Apex Rénovation SAS seront seuls compétents.
          </p>
        </div>
      </section>
    </>
  );
}
